import { api } from '../api';

export interface ActividadEntry {
  id?: string;
  empresaId?: string;
  usuarioId?: string;
  entidad: string;
  entidadId?: string;
  accion: string;
  before?: unknown;
  after?: unknown;
  ip?: string;
  userAgent?: string;
  traceId?: string;
  createdAt?: string;
}

export interface ActividadResponse {
  total: number;
  items: ActividadEntry[];
}

export interface ActividadQuery {
  empresaId?: string;
  entidad?: string;
  entidadId?: string;
  limit?: number;
}

export async function listActividad(q: ActividadQuery = {}): Promise<ActividadResponse> {
  const { data } = await api.get<ActividadResponse>('/audit', { params: q });
  return data;
}
